import { Box, IconButton, Modal } from '@mui/material';
import { ReactNode } from 'react';
import CloseIcon from '@acorn-portal/shared/src/assets/acorn/icons/circled-close-white-bg.svg';

interface ICommunicationModalProps {
	open: boolean;
	onClose: () => void;
	children: ReactNode;
}

const CommunicationModal = ({ open, onClose, children }: ICommunicationModalProps) => (
	<Modal
		open={open}
		onClose={onClose}
		aria-labelledby='communication-modal-title'
		aria-describedby='communication-modal-description'
	>
		<Box
			sx={(theme) => ({
				position: 'absolute',
				top: '50%',
				left: '50%',
				transform: 'translate(-50%, -50%)',
				maxWidth: '100%',
				bgcolor: theme.palette.background.paper,
				boxShadow: 24,
				borderRadius: '8px',
				overflow: 'hidden',
				display: 'flex',
				flexDirection: 'row',
				p: 0,
			})}
		>
			<IconButton
				onClick={onClose}
				sx={{
					position: 'absolute',
					cursor: 'pointer',
					top: 0,
					right: 0,
					p: 0,
					zIndex: 1,
					transition: 'background-color 0.2s ease-in-out',

					'&:hover': { backgroundColor: 'rgba(255, 255, 255, 0.04)' },
				}}
			>
				<img src={CloseIcon} alt={'icon'} />
			</IconButton>
			<Box id='communication-modal-content' sx={{ overflowY: 'auto', overflowX: 'hidden', padding: 0 }}>
				{children}
			</Box>
		</Box>
	</Modal>
);

export default CommunicationModal;
